export const SABBAT_INFO = {
  imbolc: {
    history: {
      fr: "Fête de la lumière renaissante et de la déesse Brigid, annonçant les premiers signes du printemps.",
      de: "Fest des wiederkehrenden Lichts und der Göttin Brigid, das die ersten Zeichen des Frühlings ankündigt.",
      it: "Festa della luce rinascente e della dea Brigid, che annuncia i primi segni della primavera.",
      en: "Festival of returning light and the goddess Brigid, heralding the first signs of spring.",
    },
    ritual: {
      fr: "Allumez des bougies, purifiez votre autel et semez vos intentions pour l'année.",
      de: "Zünde Kerzen an, reinige deinen Altar und säe deine Absichten für das Jahr.",
      it: "Accendi candele, purifica l'altare e semina le tue intenzioni per l'anno.",
      en: "Light candles, cleanse your altar and plant your intentions for the year.",
    },
  },
  ostara: {
    history: {
      fr: "Équinoxe de printemps : l'équilibre du jour et de la nuit célèbre la fertilité et le renouveau.",
      de: "Frühlings-Tagundnachtgleiche: Das Gleichgewicht von Tag und Nacht feiert Fruchtbarkeit und Erneuerung.",
      it: "Equinozio di primavera: l'equilibrio di giorno e notte celebra fertilità e rinnovamento.",
      en: "Spring equinox: the balance of day and night celebrates fertility and renewal.",
    },
    ritual: {
      fr: "Décorez des œufs, plantez des graines et honorez l'aube qui s'allonge.",
      de: "Bemale Eier, pflanze Samen und ehre die länger werdende Morgendämmerung.",
      it: "Decora uova, pianta semi e onora l'alba che si allunga.",
      en: "Decorate eggs, plant seeds and honour the lengthening dawn.",
    },
  },
  beltane: {
    history: {
      fr: "Feu de mai célébrant l'union, la passion et l'abondance de la nature en fleur.",
      de: "Maifeuer, das Vereinigung, Leidenschaft und die Fülle der blühenden Natur feiert.",
      it: "Fuoco di maggio che celebra unione, passione e abbondanza della natura in fiore.",
      en: "May fire celebrating union, passion and the abundance of nature in bloom.",
    },
    ritual: {
      fr: "Dansez autour du feu, tressez des couronnes de fleurs et sautez les flammes pour la chance.",
      de: "Tanze ums Feuer, flechte Blumenkränze und springe für Glück über die Flammen.",
      it: "Danza attorno al fuoco, intreccia corone di fiori e salta le fiamme per fortuna.",
      en: "Dance around the fire, weave flower crowns and leap the flames for luck.",
    },
  },
  litha: {
    history: {
      fr: "Solstice d'été, le jour le plus long : apogée de la puissance solaire.",
      de: "Sommersonnenwende, der längste Tag: Höhepunkt der Sonnenkraft.",
      it: "Solstizio d'estate, il giorno più lungo: apice della potenza solare.",
      en: "Summer solstice, the longest day: the peak of solar power.",
    },
    ritual: {
      fr: "Veillez au coucher du soleil, cueillez des herbes et rendez grâce à la lumière.",
      de: "Wache zum Sonnenuntergang, sammle Kräuter und danke dem Licht.",
      it: "Veglia al tramonto, raccogli erbe e rendi grazie alla luce.",
      en: "Keep vigil at sunset, gather herbs and give thanks to the light.",
    },
  },
  lughnasadh: {
    history: {
      fr: "Première moisson, en l'honneur du dieu Lugh et des premiers fruits de la terre.",
      de: "Erste Ernte zu Ehren des Gottes Lugh und der ersten Früchte der Erde.",
      it: "Primo raccolto in onore del dio Lugh e dei primi frutti della terra.",
      en: "First harvest honouring the god Lugh and the earth's first fruits.",
    },
    ritual: {
      fr: "Partagez du pain, remerciez pour l'abondance et gardez une gerbe de blé.",
      de: "Teile Brot, danke für die Fülle und bewahre eine Weizengarbe auf.",
      it: "Condividi il pane, ringrazia per l'abbondanza e conserva un covone di grano.",
      en: "Share bread, give thanks for abundance and keep a sheaf of wheat.",
    },
  },
  mabon: {
    history: {
      fr: "Équinoxe d'automne : seconde moisson et gratitude avant la nuit grandissante.",
      de: "Herbst-Tagundnachtgleiche: zweite Ernte und Dankbarkeit vor der wachsenden Nacht.",
      it: "Equinozio d'autunno: secondo raccolto e gratitudine prima della notte crescente.",
      en: "Autumn equinox: second harvest and gratitude before the growing night.",
    },
    ritual: {
      fr: "Dressez une table d'automne, faites le bilan et rééquilibrez votre foyer.",
      de: "Decke einen Herbsttisch, ziehe Bilanz und bringe dein Zuhause ins Gleichgewicht.",
      it: "Apparecchia una tavola d'autunno, fai un bilancio e riequilibra la tua casa.",
      en: "Set an autumn table, take stock and rebalance your home.",
    },
  },
  samhain: {
    history: {
      fr: "Nouvel an des sorcières : le voile entre les mondes s'amincit et l'on honore les ancêtres.",
      de: "Hexen-Neujahr: Der Schleier zwischen den Welten wird dünn und man ehrt die Ahnen.",
      it: "Capodanno delle streghe: il velo tra i mondi si assottiglia e si onorano gli antenati.",
      en: "The witches' new year: the veil between worlds thins and ancestors are honoured.",
    },
    ritual: {
      fr: "Dressez un autel aux défunts, allumez une bougie et pratiquez la divination.",
      de: "Errichte einen Ahnenaltar, zünde eine Kerze an und übe Wahrsagung.",
      it: "Allestisci un altare ai defunti, accendi una candela e pratica la divinazione.",
      en: "Set an ancestor altar, light a candle and practise divination.",
    },
  },
  yule: {
    history: {
      fr: "Solstice d'hiver : la plus longue nuit annonce la renaissance du soleil.",
      de: "Wintersonnenwende: Die längste Nacht kündigt die Wiedergeburt der Sonne an.",
      it: "Solstizio d'inverno: la notte più lunga annuncia la rinascita del sole.",
      en: "Winter solstice: the longest night heralds the sun's rebirth.",
    },
    ritual: {
      fr: "Brûlez la bûche de Yule, décorez de verdure et veillez le retour de la lumière.",
      de: "Verbrenne den Julscheit, schmücke mit Grün und wache auf die Rückkehr des Lichts.",
      it: "Brucia il ceppo di Yule, decora con il verde e veglia il ritorno della luce.",
      en: "Burn the Yule log, decorate with greenery and watch for the light's return.",
    },
  },
};
